import {
    AwardType,
    Blog2Type,
    BlogType,
    CareerTimelineType,
    LinkType,
    OurAchievementType,
    PricingPlanType,
    Project1Type,
    Project2Type,
    Project3Type,
    Project4Type,
    Project5Type,
    Service1Type,
    ICPServiceType1,
    ICPServiceType2,
    ICPServiceType3,
    ICPServiceType4,
    ICPType,
    ICPServiceOtherType1,
    ICPServiceOtherType2,
    ICPServiceOtherType3,
    ICPServiceOtherType4,
    ICPCreatorExplor,
    ICPStartupExplor,
    ICPScalingBrandExplor,
    ICPAgenciesExplor,
    ServiceExplorType,
    Service4Type,
    HomeServiceType,
    ServiceInServiceType,
    ServiceList1Type,
    ServiceList2Type,
    ServiceList3Type,
    ServiceList4Type,
    ExpertiseStartupServiceType,
    ExpertiseCreatorsServiceType,
    ExpertiseScalingBrandsServiceType,
    ExpertiseAgenciesServiceType,
    Service5Type,
    HomeServiceOtherType,
    ValuePropositionSectionType1,
    ValuePropositionSectionType2,
    ValuePropositionSectionType3,
    ValuePropositionSectionType4,
    ServiceOtherType,
    ServiceType,
    SocialType,
    TeamMemberType,
    Testimonial1Type,
    TestimonialType,
    CaseStudyBoxType,
    BfsServiceType,
} from '@/types/global';

export const ourAchievement: OurAchievementType[] = [
    { value: 80, unit: "+", label: "platforms launched for creators, brands, and agencies" },
    { value: 80, unit: "M+", label: "users engaged on Desilo-powered products" },
    { value: 80, unit: "%", label: "improved client ROI" },
    { value: 8, unit: "weeks", label: "average time-to-launch" },
];

export const project1: Project1Type[] = [
    {
        title: "Kinetic Sandscapes",
        imageUrl: "/images/project/project-1.png",
        year: 2024,
        category: "Branding",
    },
    {
        title: "Hopscotch Payments",
        imageUrl: "/images/project/project-2.png",
        year: 2024,
        category: "Development",
    },
    {
        title: "Brooklyn Brewery",
        imageUrl: "/images/project/project-3.png",
        year: 2024,
        category: "Photography",
    },
    {
        title: "Stories Worthwhile",
        imageUrl: "/images/project/project-4.png",
        year: 2024,
        category: "UI/UX Design",
    },
    {
        title: "Regenerative Farming",
        imageUrl: "/images/project/project-5.png",
        year: 2024,
        category: "Branding",
    },
    {
        title: "Fintech Accelerator",
        imageUrl: "/images/project/project-6.png",
        year: 2024,
        category: "UI/UX Design",
    },
];

export const projects2: Project3Type[] = [
    {
        title: "Kinetic Sandscapes",
        year: "2024",
        category: "Branding",
        imageUrl: "/images/project/project-2-1.png",
    },
    {
        title: "Hopscotch Payments",
        year: "2024",
        category: "Development",
        imageUrl: "/images/project/project-2-2.png",
    },
    {
        title: "Brooklyn Brewery",
        year: "2024",
        category: "Photography",
        imageUrl: "/images/project/project-2-3.png",
    },
    {
        title: "Regenerative Farming",
        year: "2024",
        category: "Branding",
        imageUrl: "/images/project/project-2-4.png",
    },
];

export const projects3: Project4Type[] = [
    {
        title: "Kinetic Sandscapes",
        description:
            "Creative Design team on demand that can design, build, ship and scale your real has development agency.",
        year: "2024",
        category: "Branding",
        imageUrl: "/images/project/project-3-1.png",
    },
    {
        title: "Hopscotch Payments",
        description:
            "Creative Design team on demand that can design, build, ship and scale your real has development agency.",
        year: "2024",
        category: "Development",
        imageUrl: "/images/project/project-3-2.png",
    },
    {
        title: "Brooklyn Brewery",
        description:
            "Creative Design team on demand that can design, build, ship and scale your real has development agency.",
        year: "2024",
        category: "Photography",
        imageUrl: "/images/project/project-3-3.png",
    },
    {
        title: "Regenerative Farming",
        description:
            "Creative Design team on demand that can design, build, ship and scale your real has development agency.",
        year: "2024",
        category: "UI/UX Design",
        imageUrl: "/images/project/project-3-4.png",
    },
];

export const caseStydyBox: CaseStudyBoxType[] = [
    {
        title: "Data-Driven Insights",
        text: "The platform enables better decision-making, aligning sales activities with business objectives.",
        imageUrl: "/images/project/portfolio-gallery-1.png",
    },
    {
        title: "Comprehensive review",
        text: "Real-time insights on workforce activities",
        imageUrl: "/images/project/portfolio-gallery-2.png",
    },
    {
        title: "User-Centric Designs",
        text: "Simplifying complex systems with simple navigation & dashboards",
        imageUrl: "/images/project/portfolio-gallery-3.png",
    }
];
export const projects4: Project1Type[] = [
    {
        title: "Cabotto",
        altText: "Cabotto social creator platform UI displayed on desktop and mobile, featuring community posts, messaging, and media sharing",
        category: "Creator monetization",
        imageUrl: "/images/project/cabotto.png",
        url: "cabotto",
    },
    {
        title: "Get2net0",
        altText: "Get2net0 social and environmental platform UI on desktop and mobile, highlighting community updates, collaboration, and sustainability actions",
        category: "Climate collaboration network",
        imageUrl: "/images/project/get2net0.png",
        url: "get2net0",
    },

];

export const projects5: Project5Type[] = [
    {
        id: 1,
        title: "Kinetic Sandscapes",
        image: "/images/project/project-2-1.png",
        year: "2024",
        category: "Branding",
        colMd: "col-md-6",
        colLg: "col-lg-4",
        align: "end",
    },
    {
        id: 2,
        title: "Hopscotch Payments",
        image: "/images/project/project-2-2.png",
        year: "2024",
        category: "Development",
        colMd: "col-md-6",
        colLg: "col-lg-7",
    },
    {
        id: 3,
        title: "Brooklyn Brewery",
        image: "/images/project/project-2-3.png",
        year: "2024",
        category: "Photography",
        colMd: "col-md-6",
        colLg: "col-lg-7",
    },
    {
        id: 4,
        title: "Regenerative Farming",
        image: "/images/project/project-2-4.png",
        year: "2024",
        category: "Branding",
        colMd: "col-md-6",
        colLg: "col-lg-4",
        align: "start",
    },
    {
        id: 5,
        title: "Stories Worthwhile",
        image: "/images/project/project-3-5.png",
        year: "2024",
        category: "UI/UX Design",
        colMd: "col-md-6",
        colLg: "col-lg-4",
        align: "end",
    },
    {
        id: 6,
        title: "Fintech Accelerator",
        image: "/images/project/project-3-6.png",
        year: "2024",
        category: "Development",
        colMd: "col-md-6",
        colLg: "col-lg-7",
    },
];

export const service1: Service1Type[] = [
    {
        icon: "/images/service/service-icon-1.svg",
        title: "Brand Strategy",
        description:
            "Brand identity design a the have to success whether you breath onfire desilo agency.",
        link: "/use-case/saas-mvp",
    },
    {
        icon: "/images/service/service-icon-2.svg",
        title: "Web Development",
        description:
            "Brand identity design a the have to success whether you breath onfire desilo agency.",
        link: "/use-case/saas-mvp",
    },
    {
        icon: "/images/service/service-icon-3.svg",
        title: "UI/UX Design",
        description:
            "Brand identity design a the have to success whether you breath onfire desilo agency.",
        link: "/use-case/saas-mvp",
    },
    {
        icon: "/images/service/service-icon-4.svg",
        title: "Digital Marketing",
        description:
            "Brand identity design a the have to success whether you breath onfire desilo agency.",
        link: "/use-case/saas-mvp",
    },
];

export const icpServices1: ICPServiceType1[] = [
    {
        title: "Content Cadence: Consistent Output",
        description:
            "Schedule ideas, auto-publish posts, approvals, maintain rhythm and never miss out.",
        link: "/use-case/posting-os-content-cadence",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        title: "Monetization Hub: Turn Fans Paid",
        description:
            "Member perks, DMs, paywalls, convert fans into steady monthly revenue streams.",
        link: "/use-case/monetization-subscriber-hubs",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        title: "Digital Store: Sell Downloads Fast",
        description:
            "Courses, templates, smooth checkout, offer bundles and upsells to boost sales.",
        link: "/use-case/digital-store-productized-assets",
        icon: "/images/service/service-icon-3.svg",
    },
    {
        title: "Community Spaces: Foster Real Ties",
        description:
            "Live chats, challenges, streaks, build deeper connections and boost retention.",
        link: "/use-case/community-spaces-engagement-loops",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        title: "Brand Kit: Sponsorship Deals Fast",
        description:
            "Auto media kits, booking links, rate cards, trackers close brand deals quicker.",
        link: "/use-case/sponsorship-brand-kit-automation",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        title: "Analytics System: Growth Metrics",
        description:
            "Dashboards for reach, ROI, churn, target content, and grow with actionable insight.",
        link: "/use-case/creator-analytics-growth-systems",
        icon: "/images/service/service-icon-3.svg",
    },
    {
        title: "Starter SaaS: Creator Utility Tools",
        description:
            "Quick modules for memberships, growth, and mini-apps adapt to unique creator needs.",
        link: "/use-case/starter-saas-modules-creator-tools",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        title: "Link-in-Bio: Cart, Bundles, Capture",
        description:
            "Mini site, gated offers, email, convert traffic to sales and leads with one link.",
        link: "/use-case/link-in-bio-storefront",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        title: "Live Video: Tag, Shop, Convert",
        description:
            "Tag products in streams, native checkout, and post-purchase flows boost revenue.",
        link: "/use-case/live-shoppable-videos",
        icon: "/images/service/service-icon-3.svg",
    },
    {
        title: "Wellness Guardrails: Balance Pace",
        description:
            "Focus modes, quiet time, signals, keep creator wellness, sustain creative output.",
        link: "/use-case/wellness-workload-guardrails",
        icon: "/images/service/service-icon-2.svg",
    },
];
export const icpServices2: ICPServiceType2[] = [
    // {
    //     title: "SaaS MVP: Fast Launch, Scale-Ready Tech",
    //     description:
    //         "Build your MVP with auth, billing, analytics, ready to test, retain, and quickly scale.",
    //     link: "/use-case/saas-mvp",
    //     icon: "/images/service/service-icon-2.svg",
    // },
    // {
    //     title: "Creator CRM: Track Campaigns & Growth",
    //     description:
    //         "All creator and campaign data in one place, easy outreach, tracking, and revenue wins.",
    //     link: "/use-case/creator-crm",
    //     icon: "/images/service/service-icon-1.svg",
    // },
    {
        title: "Creator Monetization Platforms",
        description:
            "Launch lightweight subscription, tipping, or paywalled-content tools to validate user demand fast.",
        link: "/use-case/creator-monetization-platform",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        title: "Creator-Led SaaS (AI + Workflow Tools)",
        description:
            "Ship early AI copilots for content repurposing, scriptwriting, or collab outreach to test traction.",
        link: "/use-case/creator-led-saas",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        title: "Community OS: Cohorts, Events, Courses",
        description:
            "Manage spaces, cohorts, and events, reduce churn, grow LTV, and boost fan loyalty.",
        link: "/use-case/community-os",
        icon: "/images/service/service-icon-3.svg",
    },
    {
        title: "AI Content Agents: Faster Output",
        description:
            "Automate ideas, edits, A/B tests, and targeting, boost results with minimal effort.",
        link: "/use-case/niche-social-platform",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        title: "Niche Social: Build Safe Creator Hub",
        description:
            "Launch vertical social profiles, DMs, feeds, safety tools, and network effect wins.",
        link: "/use-case/niche-social-platform",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        title: "Decentralized ID: Own Data, Portability",
        description:
            "ActivityPub/DIDs let creators control their audience, content, and payouts with no lock-in.",
        link: "/use-case/decentralized-identity-portability",
        icon: "/images/service/service-icon-3.svg",
    },
    {
        title: "Link-In-Bio Storefront: Commerce Tools",
        description:
            "Mini-site with carts, drops, bundles, capture leads and boost instant conversions.",
        link: "/use-case/link-bio-storefront-social-commerce",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        title: "Live, Shoppable Video: Commerce Win",
        description:
            "Tag products in stream/videos, native checkout turns views into frequent revenue.",
        link: "/use-case/live-shoppable-video",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        title: "Legal Hub: Contracts & Diligence",
        description:
            "Automate contracts, rights, FTC, audits, safe, compliant, and secure collaborations.",
        link: "/use-case/legal-compliance-hub",
        icon: "/images/service/service-icon-3.svg",
    },
    {
        title: "Creator Fintech: Wallets, Payouts",
        description:
            "Multi-currency, split payments, instant payouts, and predictable creator cash flow.",
        link: "/use-case/creator-fintech-rails",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        title: "Creator Wellness: Support & Recovery",
        description:
            "Wellness, check-ins, and burnout signals help creators thrive with healthy routines.",
        link: "/use-case/creator-mental-health-resilience",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        title: "Creator Passport: Trust & Compliance",
        description:
            "Portable ID with KYC, wellness, payouts, and AI ensures compliance and safe access.",
        link: "/use-case/creator-passport-trust-layer",
        icon: "/images/service/service-icon-3.svg",
    },
    {
        title: "Paywalls: Lock Content, Drive Revenue",
        description:
            "Metered reads, previews, bundles, support one-time buys, subscriptions, easy trials.",
        link: "/use-case/post-article-paywalls",
        icon: "/images/service/service-icon-2.svg",
    },
];
export const icpServices3: ICPServiceType3[] = [
    {
        title: "Platform Redesign: Fast, Accessible",
        description:
            "Upgrade UX, boost conversion, and WCAG 2.2 delivers faster flows for all audiences.",
        link: "/use-case/platform-redesign-accessibility",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        title: "Modernize Community: Real-Time Social",
        description:
            "Events, chat, moderation, scalable roles rollout with zero downtime, and drive loyalty.",
        link: "/use-case/community-platform-modernization",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        title: "Social Feed: Relevant, Safe, Smart",
        description:
            "AI ranks, dedups, safety signals boost engagement with smarter recommendations.",
        link: "/use-case/social-graph-feed-relevance",
        icon: "/images/service/service-icon-3.svg",
    },
    {
        title: "Shoppable Media: Sell Live, Win Big",
        description:
            "Tag products, enable checkout, track post-purchase flows and attribution easily.",
        link: "/use-case/shoppable-media-live-commerce",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        title: "Subscriptions: Flexible, Scalable",
        description:
            "Tiers, trials, proration, entitled bundles, and tax automate global memberships.",
        link: "/use-case/subscriptions-membership-kernel",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        title: "Global Payments: Easy, Secure, Fast",
        description:
            "Multi-processor, wallets, splits, escrow, GST, TDS, invoicing streamline payouts.",
        link: "/use-case/global-payments-payouts-tax",
        icon: "/images/service/service-icon-3.svg",
    },
    {
        title: "AI Content: Fast, Scalable, Tested",
        description:
            "Auto cutdowns, captions, scaling, multi-variant tested media, metadata ready.",
        link: "/use-case/ai-content-pipeline",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        title: "AI Safety: Suitability & Detection",
        description:
            "IP detection, multimodal moderation, disclosures, meet policy and brand goals.",
        link: "/use-case/ai-safety-brand-suitability",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        title: "Cloud Migration: Efficient, Scalable",
        description:
            "Replatform on AWS/GCP, autoscale, FinOps, blue-green cut costs, speed launches.",
        link: "/use-case/cloud-migration-cost-optimization",
        icon: "/images/service/service-icon-3.svg",
    },
    {
        title: "Data Warehouse: Unified, Event-Driven",
        description:
            "Schema, BigQuery, Snowflake, and ETL unify self-serve BI for teams and leadership.",
        link: "/use-case/data-warehouse-cdc-unification",
        icon: "/images/service/service-icon-2.svg",
    },
];

export const icpServices4: ICPServiceType4[] = [
    {
        title: "Influencer Discovery: Fast Vetting",
        description:
            "Find creators with rich filters and fast verification for authentic brand matches.",
        link: "/use-case/influencer-discovery-vetting",
        icon: "/images/service/service-icon-2.svg",
    },
    // {
    //     title: "End-to-End Campaigns: Trusted Ops",
    //     description:
    //         "Run campaigns, track deliverables, approve, and manage all assets in one place.",
    //     link: "/use-case/end-to-end-campaign-management",
    //     icon: "/images/service/service-icon-1.svg",
    // },
    // {
    //     title: "Content Planning: Real-Time Collab",
    //     description:
    //         "Co-design, review, and schedule quickly, with real-time feedback and approvals included.",
    //     link: "/use-case/collaborative-content-planning",
    //     icon: "/images/service/service-icon-3.svg",
    // },
    {
        title: "Campaign & Brand Deal Workflow ",
        description:
            "Briefs, deliverables, approvals, and reporting in one pipeline to reduce chaos and lost margins.",
        link: "/use-case/campaign-workflow-automation",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        title: "Outbound Sales Intelligence for Brand Partnerships ",
        description:
            "Proposal generators, case-study builders, and performance snapshots to win deals faster.",
        link: "/use-case/outbound-sales-pitch-intelligence",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        title: "Analytics & Reporting: ROI Visible",
        description:
            "Track reach, conversion, ROI, client dashboards and exports drive better decisions.",
        link: "/use-case/performance-analytics-reporting",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        title: "Automated Outreach: Unified CRM",
        description:
            "Bulk messaging, pipeline, contracts, manage creator relations and nurture deals.",
        link: "/use-case/automated-outreach-crm",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        title: "Legal Workflow: Fast, Compliant Ops",
        description:
            "Draft contracts, e-sign, schedule payments, stay error-free and always compliant.",
        link: "/use-case/legal-contract-workflow-management",
        icon: "/images/service/service-icon-3.svg",
    },
    {
        title: "Team Collaboration: Scale Easily",
        description:
            "Multi-user roles, tasks, dashboards, scale ops and track progress with every deal.",
        link: "/use-case/scalable-team-collaboration",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        title: "Brand Safety: Compliance Assured",
        description:
            "Detect fraud, monitor policies, FTC alerts, protect brands and ensure trust always.",
        link: "/use-case/brand-safety-compliance-monitoring",
        icon: "/images/service/service-icon-1.svg",
    },
];

export const services4: Service4Type[] = [
    {
        title: "01 ─ Brand strategy",
        description:
            "We delve deep into understanding your target audience and competitive landscape. With this insight, we craft compelling brand stories, defining your company values and messaging.",
        svgPath:
            "M52 1.1365e-06L52 52L9.78146e-07 0L52 1.1365e-06ZM26 26L26 52L0 26L26 26Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "02 ─ Web development",
        description:
            "We delve deep into understanding your target audience and competitive landscape. With this insight, we craft compelling brand stories, defining your company values and messaging.",
        svgPath:
            "M26 52C32.8956 52 39.5088 49.2607 44.3848 44.3848C49.2607 39.5088 52 32.8956 52 26C52 19.1044 49.2607 12.4912 44.3848 7.61525C39.5088 2.7393 32.8956 2.40725e-05 26 2.27299e-05L26 26L26 52ZM0 52C6.89562 52 13.5088 49.2607 18.3848 44.3848C23.2607 39.5088 26 32.8956 26 26C26 19.1044 23.2607 12.4912 18.3848 7.61522C13.5088 2.73928 6.89563 1.34263e-06 6.19888e-06 0L0 52Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "03 ─ UI/UX design",
        description:
            "We delve deep into understanding your target audience and competitive landscape. With this insight, we craft compelling brand stories, defining your company values and messaging.",
        svgPath:
            "M35.36 0L26 9.36L16.64 7.27358e-07H1.54563e-06V16.64L9.36 26L0 35.36L8.18277e-07 52H16.64L26 42.64L35.36 52H52V35.36L42.64 26L52 16.64V7.27358e-07L35.36 0Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "04 ─ Digital marketing",
        description:
            "We delve deep into understanding your target audience and competitive landscape. With this insight, we craft compelling brand stories, defining your company values and messaging.",
        svgPath:
            "M52 2.34V0L0 3.44309e-07L4.11567e-08 2.34C2.24047e-07 12.7384 6.10429 21.7111 14.9249 25.87C6.10429 30.0289 -1.84046e-07 39.0016 2.56176e-07 49.4L3.66248e-07 52L52 52V49.4C52 39.0016 45.8957 30.0289 37.0751 25.87C45.8957 21.7111 52 12.7384 52 2.34Z",
        viewBox: "0 0 52 52",
    },
];
export const homeService: HomeServiceType[] = [
    {
        title: "Strategy & ideation",
        description:
            "We help you find product-market fit. Together, we define your ideal customer profile, value proposition, and business model. We design experiments and metrics to turn your ideas into testable product bets.",
        tags: ["JTBD Research", "Market & Competitor Maps", "Experiment Roadmap", "PMF Metrics"],
        icon: "/images/service/ideation.svg",
        url: "/strategy-ideation",
    },
    {
        title: "Digital product experiences",
        description:
            "We design experiences your users love and pay for. We craft UX/UI and community loops, prototype fast, test with real people, and guide you to subscriptions, upsells, or starter SaaS.",
        tags: ["UX/UI Design", "Design System", "Usability Testing", "Monetization Flows"],
        icon: "/images/service/experience.svg",
        url: "/digital-experiences",
    },
    {
        title: "Technology & Transformation",
        description:
            "We modernize your core so you scale confidently. We plan architectures, APIs, and integrations with security and governance, then add applied AI: personalization, automations, agents, and ship with CI/CD and observability.",
        tags: ["Cloud & DevOps", "Data & Integrations", "Security & Governance", "Applied AI & Agents"],
        icon: "/images/service/transformation.svg",
        url: "/technology-transformation",
    },
    {
        title: "Go-to-market & Growth systems",
        description:
            "We turn products into pipelines. We build onboarding, lifecycle messaging, pricing, referrals, and analytics so growth compounds. You get attribution and CRM integrations that close the loop to revenue.",
        tags: ["Lifecycle & Messaging", "Experimentation & Analytics", "Attribution & CRM", "Pricing & Referrals"],
        icon: "/images/service/market.svg",
        url: "/go-to-market-growth",
    },
];

export const serviceInService: ServiceInServiceType[] = [
    {
        title: "Strategy & Ideation",
        description:
            "We help you find product-market fit. Together, we define your ideal customer profile, value proposition, and business model. We design experiments and metrics to turn your ideas into testable product bets.",
        tags: ["JTBD Research", "Market & Competitor Maps", "Experiment Roadmap", "PMF Metrics"],
        icon: "/images/service/ideation.svg",
        url: "/strategy-ideation",
    },
    {
        title: "Digital product experiences",
        description:
            "We design experiences your users love and pay for. We craft UX/UI and community loops, prototype fast, test with real people, and guide you to subscriptions, upsells, or starter SaaS.",
        tags: ["UX/UI Design", "Design System", "Usability Testing", "Monetization Flows"],
        icon: "/images/service/experience.svg",
        url: "/digital-experiences",
    },
    {
        title: "Technology & Transformation",
        description:
            "We modernize your core so you scale confidently. We plan architectures, APIs, and integrations with security and governance, then add applied AI: personalization, automations, agents, and ship with CI/CD and observability.",
        tags: ["Cloud & DevOps", "Data & Integrations", "Security & Governance", "Applied AI & Agents"],
        icon: "/images/service/transformation.svg",
        url: "/technology-transformation",
    },
    {
        title: "Go-to-market & Growth systems",
        description:
            "We turn products into pipelines. We build onboarding, lifecycle messaging, pricing, referrals, and analytics so growth compounds. You get attribution and CRM integrations that close the loop to revenue.",
        tags: ["Lifecycle & Messaging", "Experimentation & Analytics", "Attribution & CRM", "Pricing & Referrals"],
        icon: "/images/service/market.svg",
        url: "/go-to-market-growth",
    },
];

export const serviceList1: ServiceList1Type[] = [
    {
        title: "Product ideation sprint",
        description:
            "We frame the problem, map assumptions, and generate solutions that can be tested within days.",
        linkText: "View details ",
        tags: ["Problem Framing", "HMW Prompts", "Assumption Map", "RAT Test"],
        svgPath:
            "M52 1.1365e-06L52 52L9.78146e-07 0L52 1.1365e-06ZM26 26L26 52L0 26L26 26Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Customer interviews and JTBD",
        description:
            "We interview real users, extract jobs to be done, and translate pains into product opportunities.",
        linkText: "View details ",
        tags: ["Interviews", "JTBD", "Insights Repo", "Opportunity Themes"],
        svgPath:
            "M26 52C32.8956 52 39.5088 49.2607 44.3848 44.3848C49.2607 39.5088 52 32.8956 52 26C52 19.1044 49.2607 12.4912 44.3848 7.61525C39.5088 2.7393 32.8956 2.40725e-05 26 2.27299e-05L26 26L26 52ZM0 52C6.89562 52 13.5088 49.2607 18.3848 44.3848C23.2607 39.5088 26 32.8956 26 26C26 19.1044 23.2607 12.4912 18.3848 7.61522C13.5088 2.73928 6.89563 1.34263e-06 6.19888e-06 0L0 52Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Market research and competitor analysis",
        description:
            "We scan the category, analyze competitors, and map differentiation so positioning, pricing, and roadmap are grounded in reality.",
        linkText: "View details ",
        tags: ["Category Map", "Positioning", "Pricing Scan", "SWOT", "Opportunity Grid"],
        svgPath:
            "M26 52C32.8956 52 39.5088 49.2607 44.3848 44.3848C49.2607 39.5088 52 32.8956 52 26C52 19.1044 49.2607 12.4912 44.3848 7.61525C39.5088 2.7393 32.8956 2.40725e-05 26 2.27299e-05L26 26L26 52ZM0 52C6.89562 52 13.5088 49.2607 18.3848 44.3848C23.2607 39.5088 26 32.8956 26 26C26 19.1044 23.2607 12.4912 18.3848 7.61522C13.5088 2.73928 6.89563 1.34263e-06 6.19888e-06 0L0 52Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Market sizing and reach model",
        description:
            "We size demand and model bottom-up TAM, then outline the channels most likely to reach your audience with realistic CAC and payback.",
        linkText: "View details ",
        tags: ["TAM", "SAM", "SOM", "CAC/LTV", "Channel Mix", "Benchmarks"],
        svgPath:
            "M35.36 0L26 9.36L16.64 7.27358e-07H1.54563e-06V16.64L9.36 26L0 35.36L8.18277e-07 52H16.64L26 42.64L35.36 52H52V35.36L42.64 26L52 16.64V7.27358e-07L35.36 0Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Value proposition and offers",
        description:
            "We sharpen the promise, define must have outcomes, and shape starter offers users will pay for.",
        linkText: "View details ",
        tags: ["Messaging", "Benefits", "Proof Points", "Offer Tiers"],
        svgPath:
            "M35.36 0L26 9.36L16.64 7.27358e-07H1.54563e-06V16.64L9.36 26L0 35.36L8.18277e-07 52H16.64L26 42.64L35.36 52H52V35.36L42.64 26L52 16.64V7.27358e-07L35.36 0Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Experiment design and metrics",
        description:
            "We turn ideas into tests with success criteria and a build measure learn loop you can run.",
        linkText: "View details ",
        tags: ["Hypotheses", "KPIs", "Test Cards", "Decision Log"],
        svgPath:
            "M52 1.1365e-06L52 52L9.78146e-07 0L52 1.1365e-06ZM26 26L26 52L0 26L26 26Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Roadmap and resourcing",
        description:
            "We prioritize the riskiest bets first and create a week by week plan that the team can execute.",
        linkText: "View details ",
        tags: ["Prioritization", "Milestones", "Risks", "Budget"],
        svgPath:
            "M26 52C32.8956 52 39.5088 49.2607 44.3848 44.3848C49.2607 39.5088 52 32.8956 52 26C52 19.1044 49.2607 12.4912 44.3848 7.61525C39.5088 2.7393 32.8956 2.40725e-05 26 2.27299e-05L26 26L26 52ZM0 52C6.89562 52 13.5088 49.2607 18.3848 44.3848C23.2607 39.5088 26 32.8956 26 26C26 19.1044 23.2607 12.4912 18.3848 7.61522C13.5088 2.73928 6.89563 1.34263e-06 6.19888e-06 0L0 52Z",
        viewBox: "0 0 52 52",
    },
];

export const serviceList2: ServiceList2Type[] = [
    {
        title: "Sitemap and information architecture",
        description:
            "We map content, permissions, and navigation so users find what they need with fewer clicks.",
        linkText: "View details ",
        tags: ["IA", "Navigation", "Roles", "Content Model"],
        svgPath:
            "M52 1.1365e-06L52 52L9.78146e-07 0L52 1.1365e-06ZM26 26L26 52L0 26L26 26Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Wireframes and user flows",
        description:
            "We sketch the core journeys and states so edge cases are handled before pixels and code.",
        linkText: "View details ",
        tags: ["Flows", "Lo Fi Wireframes", "States", "Empty States"],
        svgPath:
            "M26 52C32.8956 52 39.5088 49.2607 44.3848 44.3848C49.2607 39.5088 52 32.8956 52 26C52 19.1044 49.2607 12.4912 44.3848 7.61525C39.5088 2.7393 32.8956 2.40725e-05 26 2.27299e-05L26 26L26 52ZM0 52C6.89562 52 13.5088 49.2607 18.3848 44.3848C23.2607 39.5088 26 32.8956 26 26C26 19.1044 23.2607 12.4912 18.3848 7.61522C13.5088 2.73928 6.89563 1.34263e-06 6.19888e-06 0L0 52Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Content design and voice",
        description:
            "We write the microcopy that guides choices, reduces anxiety, and matches brand voice. Empty, error, and success messages are clear.",
        linkText: "View details ",
        tags: ["UX Writing", "Tone", "Microcopy", "Error States", "Style Guide"],
        svgPath:
            "M52 1.1365e-06L52 52L9.78146e-07 0L52 1.1365e-06ZM26 26L26 52L0 26L26 26Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Visual design and prototypes",
        description:
            "We create a visual language and interactive prototypes that make the value obvious.",
        linkText: "View details ",
        tags: ["Visual System", "Interactive Prototype", "Motion", "Accessibility"],
        svgPath:
            "M35.36 0L26 9.36L16.64 7.27358e-07H1.54563e-06V16.64L9.36 26L0 35.36L8.18277e-07 52H16.64L26 42.64L35.36 52H52V35.36L42.64 26L52 16.64V7.27358e-07L35.36 0Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Design system and tokens",
        description:
            "We build reusable components and tokens so design and development move in sync.",
        linkText: "View details ",
        tags: ["Components", "Tokens", "Guidelines", "Figma Library"],
        svgPath:
            "M52 1.1365e-06L52 52L9.78146e-07 0L52 1.1365e-06ZM26 26L26 52L0 26L26 26Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Usability testing and iteration",
        description:
            "We test with real users, log issues, and ship fixes that improve time to first value.",
        linkText: "View details ",
        tags: ["Scripts", "Sessions", "Findings", "Priority Fixes"],
        svgPath:
            "M26 52C32.8956 52 39.5088 49.2607 44.3848 44.3848C49.2607 39.5088 52 32.8956 52 26C52 19.1044 49.2607 12.4912 44.3848 7.61525C39.5088 2.7393 32.8956 2.40725e-05 26 2.27299e-05L26 26L26 52ZM0 52C6.89562 52 13.5088 49.2607 18.3848 44.3848C23.2607 39.5088 26 32.8956 26 26C26 19.1044 23.2607 12.4912 18.3848 7.61522C13.5088 2.73928 6.89563 1.34263e-06 6.19888e-06 0L0 52Z",
        viewBox: "0 0 52 52",
    },
];

export const serviceList3: ServiceList3Type[] = [
    {
        title: "SaaS platform engineering",
        description:
            "We implement core services with clean APIs, billing, auth, and analytics that scale.",
        linkText: "View details ",
        tags: ["Services", "APIs", "Auth", "Billing"],
        svgPath:
            "M52 1.1365e-06L52 52L9.78146e-07 0L52 1.1365e-06ZM26 26L26 52L0 26L26 26Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Web application delivery",
        description:
            "We ship secure, performant web apps with integration ready backends and clear observability.",
        linkText: "View details ",
        tags: ["Web App", "Performance", "Logging", "Alerts"],
        svgPath:
            "M26 52C32.8956 52 39.5088 49.2607 44.3848 44.3848C49.2607 39.5088 52 32.8956 52 26C52 19.1044 49.2607 12.4912 44.3848 7.61525C39.5088 2.7393 32.8956 2.40725e-05 26 2.27299e-05L26 26L26 52ZM0 52C6.89562 52 13.5088 49.2607 18.3848 44.3848C23.2607 39.5088 26 32.8956 26 26C26 19.1044 23.2607 12.4912 18.3848 7.61522C13.5088 2.73928 6.89563 1.34263e-06 6.19888e-06 0L0 52Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Mobile application delivery",
        description:
            "We build mobile experiences that mirror key value, with efficient code sharing where it makes sense.",
        linkText: "View details ",
        tags: ["iOS", "Android", "Offline", "Push"],
        svgPath:
            "M35.36 0L26 9.36L16.64 7.27358e-07H1.54563e-06V16.64L9.36 26L0 35.36L8.18277e-07 52H16.64L26 42.64L35.36 52H52V35.36L42.64 26L52 16.64V7.27358e-07L35.36 0Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Applied AI and agents",
        description:
            "We add personalization, recommendations, assistants, and workflow agents tied to KPIs.",
        linkText: "View details ",
        tags: ["Personalization", "Recs", "Agents", "Automation"],
        svgPath:
            "M35.36 0L26 9.36L16.64 7.27358e-07H1.54563e-06V16.64L9.36 26L0 35.36L8.18277e-07 52H16.64L26 42.64L35.36 52H52V35.36L42.64 26L52 16.64V7.27358e-07L35.36 0Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "CI/CD and environments",
        description:
            "We set up pipelines, staging, and release discipline so shipping is calm and frequent.",
        linkText: "View details ",
        tags: ["Pipelines", "Staging", "Feature Flags", "Rollbacks"],
        svgPath:
            "M52 1.1365e-06L52 52L9.78146e-07 0L52 1.1365e-06ZM26 26L26 52L0 26L26 26Z",
        viewBox: "0 0 52 52",
    },
];

export const serviceList4: ServiceList4Type[] = [
    {
        title: "GTM readiness audit",
        description:
            "Is your launch plan solid? We'll evaluate your funnel, messaging, and market fit to find actionable opportunities for a game-changing launch.",
        linkText: "View details ",
        tags: ["Funnel Review", "Messaging Alignment", "Market Fit Analysis"],
        svgPath:
            "M52 1.1365e-06L52 52L9.78146e-07 0L52 1.1365e-06ZM26 26L26 52L0 26L26 26Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Launch campaigns",
        description:
            "Let's make some noise. We orchestrate high-impact product releases by integrating paid, organic, and influencer outreach to maximize buzz, reach, and signups.",
        linkText: "View details ",
        tags: ["Multi-Channel Blasts", "Referral Loops", "Influencer Activations"],
        svgPath:
            "M26 52C32.8956 52 39.5088 49.2607 44.3848 44.3848C49.2607 39.5088 52 32.8956 52 26C52 19.1044 49.2607 12.4912 44.3848 7.61525C39.5088 2.7393 32.8956 2.40725e-05 26 2.27299e-05L26 26L26 52ZM0 52C6.89562 52 13.5088 49.2607 18.3848 44.3848C23.2607 39.5088 26 32.8956 26 26C26 19.1044 23.2607 12.4912 18.3848 7.61522C13.5088 2.73928 6.89563 1.34263e-06 6.19888e-06 0L0 52Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Acquisition & retention strategy",
        description:
            "Growth is about more than just new users. We design every touchpoint, from onboarding flows to viral campaigns, to attract, activate, and retain users who will stick around for the long haul.",
        linkText: "View details ",
        tags: ["User Onboarding", "Retention Playbooks", "Growth Analytics"],
        svgPath:
            "M35.36 0L26 9.36L16.64 7.27358e-07H1.54563e-06V16.64L9.36 26L0 35.36L8.18277e-07 52H16.64L26 42.64L35.36 52H52V35.36L42.64 26L52 16.64V7.27358e-07L35.36 0Z",
        viewBox: "0 0 52 52",
    },
    {
        title: "Optimization & insights",
        description:
            "Your growth engine should only get faster. Through ongoing analysis, A/B testing, and continuous tuning, we ensure your platform becomes more efficient over time.",
        linkText: "View details ",
        tags: ["Analytics Dashboards", "A/B Testing", "Conversion Optimization"],
        svgPath:
            "M35.36 0L26 9.36L16.64 7.27358e-07H1.54563e-06V16.64L9.36 26L0 35.36L8.18277e-07 52H16.64L26 42.64L35.36 52H52V35.36L42.64 26L52 16.64V7.27358e-07L35.36 0Z",
        viewBox: "0 0 52 52",
    },
];


export const expertiseStartupService: ExpertiseStartupServiceType[] = [
    {
        title: "Strategy & ideation",
        description:
            "We help you find signal quickly: ICP, value proposition, test plan, and an investor-ready roadmap tied to clear metrics.",
        tags: ["ICP and JTBD", "Experiment Plan", "PMF Metrics", "Investor Narrative"],
        icon: "/images/service/ideation.svg",
        link: "/service/strategy-ideation",
    },
    {
        title: "Digital product experiences",
        description:
            "We design a crisp MVP with clean UX, onboarding, paywalls, and usability loops that lift activation and paid conversion.",
        tags: ["UX and UI", "Design System", "Usability Testing", "Monetization Flows"],
        icon: "/images/service/experience.svg",
        link: "/service/digital-experiences",
    },
    {
        title: "Technology & transformation",
        description:
            "We build a modular stack with APIs, integrations, security, and applied AI for onboarding and recommendations.",
        tags: ["Cloud and DevOps", "Data and Integrations", "Security and Governance", "Applied AI"],
        icon: "/images/service/transformation.svg",
        link: "/service/technology-transformation",
    },
    {
        title: "Go to market & growth systems",
        description:
            "We turn product into pipelines with lifecycle messaging, pricing, referrals, and analytics that prove traction.",
        tags: ["Lifecycle Journeys", "Experimentation and Analytics", "Attribution and CRM", "Pricing and Referrals"],
        icon: "/images/service/market.svg",
        link: "/service/go-to-market-growth",
    },
];
export const expertiseCreatorsService: ExpertiseCreatorsServiceType[] = [
    {
        title: "Strategy & ideation",
        description:
            "We clarify your niche, offers, cadence, and lead magnets with a simple weekly plan you can stick to.",
        tags: ["Niche and Offers", "Content Cadence", "Lead Magnets", "Funnel Map"],
        icon: "/images/service/ideation.svg",
        link: "/service/strategy-ideation",
    },
    {
        title: "Digital product experiences",
        description:
            "We craft your posting OS, subscriber hub, perks, and community loops that keep paying fans engaged.",
        tags: ["Posting OS", "Paywalls and Tiers", "Community Features", "Retention"],
        icon: "/images/service/experience.svg",
        link: "/service/digital-experiences",
    },
    {
        title: "Technology & transformation",
        description:
            "We give you a fast and secure stack with checkout, payouts, dashboards, and lightweight SaaS modules, plus AI for captions and support.",
        tags: ["Checkout and Payouts", "Creator Dashboards", "Starter SaaS", "AI Assistants"],
        icon: "/images/service/transformation.svg",
        link: "/service/technology-transformation",
    },
    {
        title: "Go to market & growth systems",
        description:
            "We set up email and SMS journeys, offers, bundles, and analytics so you know what to double down on.",
        tags: ["Lifecycle Messaging", "Offers and Bundles", "Attribution", "LTV and Churn"],
        icon: "/images/service/market.svg",
        link: "/service/go-to-market-growth",
    },
];

export const expertiseScalingBrandsService: ExpertiseScalingBrandsServiceType[] = [
    {
        title: "Strategy & ideation",
        description:
            "We align outcomes, segments, and journeys, then map a phased roadmap with executive ready KPIs and risk controls.",
        tags: ["Segmentation", "Journey Maps", "KPI Framework", "Phased Roadmap"],
        icon: "/images/service/ideation.svg",
        link: "/service/strategy-ideation",
    },
    {
        title: "Digital product experiences",
        description:
            "We replatform UX with a design system, faster flows, and community features that lift conversion and NPS.",
        tags: ["Design System", "Performance", "Accessibility", "Community"],
        icon: "/images/service/experience.svg",
        link: "/service/digital-experiences",
    },
    {
        title: "Technology & Transformation",
        description:
            "We implement enterprise grade foundations like SSO, SCIM, RBAC, audit logs, and CDP or CRM integrations, plus applied AI for personalization and automation.",
        tags: ["SSO and SCIM", "RBAC and Audits", "CDP or CRM", "Personalization and Automation"],
        icon: "/images/service/transformation.svg",
        link: "/service/technology-transformation",
    },
    {
        title: "Go to market & growth systems",
        description:
            "We close the loop with pricing, lifecycle programs, referrals, experimentation, and ROI dashboards that make wins visible.",
        tags: ["Pricing and Packaging", "Lifecycle", "Experimentation", "ROI Dashboards"],
        icon: "/images/service/market.svg",
        link: "/service/go-to-market-growth",
    },
];

export const expertiseAgenciesService: ExpertiseAgenciesServiceType[] = [
    {
        title: "Strategy & ideation",
        description:
            "We audit your deal desk and operations, define SLAs and playbooks, and prioritize automations that unlock capacity first.",
        tags: ["Ops Audit", "SLAs and Playbooks", "Capacity Model", "Automation Map"],
        icon: "/images/service/ideation.svg",
        link: "/service/strategy-ideation",
    },
    {
        title: "Digital product experiences",
        description:
            "We design manager first UX with pipelines, briefs, approvals, calendars, and client portals that keep campaigns on rails.",
        tags: ["Deal CRM", "Briefs and Approvals", "Calendars", "Client Portals"],
        icon: "/images/service/experience.svg",
        link: "/service/digital-experiences",
    },
    {
        title: "Technology & transformation",
        description:
            "We integrate CRM, e-sign, payouts, and rights management, and we add AI agents for outreach, chatter, and support with governance.",
        tags: ["Integrations", "Contracts and Payouts", "Rights and Compliance", "AI Agents"],
        icon: "/images/service/transformation.svg",
        link: "/service/technology-transformation",
    },
    {
        title: "Go to market & growth systems",
        description:
            "We help you win and retain more with proposal templates, pricing intelligence, attribution, and reporting clients trust.",
        tags: ["Proposal Library", "Pricing Intelligence", "Attribution", "Executive Reports"],
        icon: "/images/service/market.svg",
        link: "/service/go-to-market-growth",
    },
];

export const services5: Service5Type[] = [
    {
        title: "Branding design",
        description:
            "Brand identity design a the have to success whether you breath onfire desilo agency.",
        link: "",
    },
    {
        title: "Product design",
        description:
            "Brand identity design a the have to success whether you breath onfire desilo agency.",
        link: "",
    },
    {
        title: "Graphic design",
        description:
            "Brand identity design a the have to success whether you breath onfire desilo agency.",
        link: "",
    },
    {
        title: "No-code develop",
        description:
            "Brand identity design a the have to success whether you breath onfire desilo agency.",
        link: "",
    },
];

export const icpCreatorExplor: ICPCreatorExplor[] = [
    {
        title: "Startups",
        description:
            "Launch an investor ready MVP, validate with real users, and scale on the same stack.",
        link: "/startup",
        btnText: "Explore startup solutions"
    },
    {
        title: "Agencies & Creator managers",
        description:
            "Land more brand deals and run creator ops faster with AI pipelines and on brand agents.",
        link: "/agency-manager",
        btnText: "Explore agency solutions"
    },
    {
        title: "Established & Growing",
        description:
            "Upgrade experience, add applied AI, and build owned communities that grow retention and LTV.",
        link: "/established-growing",
        btnText: "Explore established & growing solutions"
    }
];

export const icpStartupExplor: ICPStartupExplor[] = [
    {
        title: "Agencies & Creator managers",
        description:
            "Land more brand deals and run creator ops faster with AI pipelines and on brand agents.",
        link: "/agency-manager",
        btnText: "Explore agency solutions"
    },
    {
        title: "Established & Growing",
        description:
            "Upgrade experience, add applied AI, and build owned communities that grow retention and LTV.",
        link: "/established-growing",
        btnText: "Explore established & growing solutions"
    },
    {
        title: "Creators",
        description:
            "Post consistently, convert fans to subscribers, and evolve into your own SaaS.",
        link: "/creator",
        btnText: "Explore creator solutions"
    },
];

export const icpScalingBrandExplor: ICPScalingBrandExplor[] = [
    {
        title: "Creators",
        description:
            "Post consistently, convert fans to subscribers, and evolve into your own SaaS.",
        link: "/creator",
        btnText: "Explore creator solutions"
    },
    {
        title: "Startups",
        description:
            "Launch an investor ready MVP, validate with real users, and scale on the same stack.",
        link: "/startup",
        btnText: "Explore startup solutions"
    },
    {
        title: "Agencies & Creator managers",
        description:
            "Land more brand deals and run creator ops faster with AI pipelines and on brand agents.",
        link: "/agency-manager",
        btnText: "Explore agency solutions"
    },
];

export const icpAgenciesExplor: ICPAgenciesExplor[] = [
    {
        title: "Established & Growing",
        description:
            "Upgrade experience, add applied AI, and build owned communities that grow retention and LTV.",
        link: "/established-growing",
        btnText: "Explore established & growing solutions"
    },
    {
        title: "Creators",
        description:
            "Post consistently, convert fans to subscribers, and evolve into your own SaaS.",
        link: "/creator",
        btnText: "Explore creator solutions"
    },
    {
        title: "Startups",
        description:
            "Launch an investor ready MVP, validate with real users, and scale on the same stack.",
        link: "/startup",
        btnText: "Explore startup solutions"
    }
];

export const serviceExplor: ServiceExplorType[] = [
    {
        title: "Strategy & ideation",
        description:
            "Find product market fit faster with testable bets. We align ICP, value proposition, and a simple experiment plan tied to clear metrics.",
        link: "/service/strategy-ideation",
        btnText: "Explore strategy & ideation"
    },
    {
        title: "Digital product experiences",
        description:
            "Ship lovable product experiences that convert and retain. We design the journeys, prototypes, and design system your users will actually use.",
        link: "/service/digital-experiences",
        btnText: "Explore digital product experiences"
    },
    {
        title: "Technology & transformation",
        description:
            "Scale on a modular, secure stack with applied Al. We plan architectures, integrations, and Cl and CD so shipping stays calm and frequent.",
        link: "/service/technology-transformation",
        btnText: "Explore technology & transformation"
    },
    {
        title: "Go to market & growth systems",
        description:
            "Turn product into repeatable growth with measurable ROI. We wire onboarding, lifecycle, pricing, referrals, and analytics that close the loop to revenue.",
        link: "/service/go-to-market-growth",
        btnText: "Explore go to market & growth systems"
    }
];

export const homeServiceOther: HomeServiceOtherType[] = [
    {
        title: "MVP to PMF playbook",
        description:
            "A step-by-step plan to ship a lovable MVP, measure traction, and scale on the same stack.",
        icon: "/images/tools/book.svg",
        target: "",
        buttonText: "Download the playbook",
    },
    {
        title: "Posting system & monetization kit",
        description:
            "A simple weekly rhythm, templates, and funnels to turn fans into paying subscribers and outline the path to your own SaaS.",
        icon: "/images/tools/audit.svg",
        target: "",
        buttonText: "Get the kit",
    },
    {
        title: "5-Minute growth audit",
        description:
            "A quick readout on deal flow, campaign ops, and AI opportunities so one manager handles more creators with less busywork.",
        icon: "/images/tools/target.svg",
        target: "",
        buttonText: "Get my free audit",
    }
];

export const serviceOther: ServiceOtherType[] = [
    {
        title: "Creator-Economy experts",
        description:
            "We breathe the creator economy. We speak the language of subscriptions, community, and creator-ops so your product choices match real behavior and real revenue.",
        icon: "/images/service/why_desilo_1.svg",
        delay: "0.30"
    },
    {
        title: "Rapid, agile delivery",
        description:
            "We move quickly without throwaway work. Short discovery, weekly demos, and usable increments that ship in weeks, not months.",
        icon: "/images/service/why_desilo_2.svg",
        delay: "0.50"
    },
    {
        title: "End-to-End partnership",
        description:
            "Strategy, design, engineering, and growth work as one team. You get one accountable partner from first idea to measurable outcomes.",
        icon: "/images/service/why_desilo_3.svg",
        delay: "0.70"
    }
];

export const valuePropositionSection1: ValuePropositionSectionType1[] = [
    {
        title: "Creator-Economy experts",
        description:
            "Our deep focus on creator platforms and community SaaS means we understand your language and can solve your unique challenges.",
        icon: "/images/service/service-icon-1.svg",
        delay: "0.30",
    },
    {
        title: "Data-Driven Insights",
        description:
            "Every recommendation we make is backed by rigorous research, including market trends, user analytics, and competitive audits, to ensure your roadmap hits the mark.",
        icon: "/images/service/service-icon-2.svg",
        delay: "0.50",
    },
    {
        title: "Rapid Validation",
        description:
            "Through innovation sprints and proof-of-concept prototypes, we help you test ideas quickly, reduce development risks, and secure stakeholder buy-in.",
        icon: "/images/service/service-icon-3.svg",
        delay: "0.70",
    },
    {
        title: "Customized Roadmaps",
        description:
            "We don't believe in one-size-fits-all solutions. Your product vision, funding timeline, and market opportunities guide a tailored strategy that's built to scale with you.",
        icon: "/images/service/service-icon-4.svg",
        delay: "0.90",
    },
    {
        title: "End-to-End partnership",
        description:
            "From initial discovery to strategic planning, we become an extension of your team, aligning goals, resources, and execution for seamless delivery.",
        icon: "/images/service/service-icon-4.svg",
        delay: "1.10",
    }
];

export const valuePropositionSection2: ValuePropositionSectionType2[] = [
    {
        title: "User-Obsessed",
        description:
            "We design experiences that delight real people, driving engagement, retention, and advocacy from day one.",
        icon: "/images/service/service-icon-1.svg",
        delay: "0.30",
    },
    {
        title: "Brand-First Approach",
        description:
            "We weave your unique identity into every screen, making your platform instantly recognizable and trustworthy.",
        icon: "/images/service/service-icon-2.svg",
        delay: "0.50",
    },
    {
        title: "Rapid Iteration",
        description:
            "Our agile prototyping and user feedback loops reduce guesswork, accelerate launch times, and deliver designs that users love.",
        icon: "/images/service/service-icon-3.svg",
        delay: "0.70",
    },
    {
        title: "Cross-Platform Excellence",
        description:
            "From SaaS dashboards to mobile apps, our design systems ensure flawless usability wherever your users are.",
        icon: "/images/service/service-icon-4.svg",
        delay: "0.90",
    },
    {
        title: "Accessibility By Design",
        description:
            "Every experience we build is tested for accessibility, expanding your reach and enhancing usability for all users.",
        icon: "/images/service/service-icon-4.svg",
        delay: "1.10",
    }
];

export const valuePropositionSection3: ValuePropositionSectionType3[] = [
    {
        title: "Built for Scale",
        description:
            "Our platforms are designed to support 10x user growth without costly rewrites or architectural bottlenecks.",
        icon: "/images/service/service-icon-1.svg",
        delay: "0.30",
    },
    {
        title: "Engineering Excellence",
        description:
            "Your tech is battle-tested through meticulous code, rigorous QA, and real-world performance benchmarks.",
        icon: "/images/service/service-icon-2.svg",
        delay: "0.50",
    },
    {
        title: "Cloud-First Mindset",
        description:
            "We create lean, secure deployments that maximize uptime, cost-efficiency, and future flexibility.",
        icon: "/images/service/service-icon-3.svg",
        delay: "0.70",
    },
    {
        title: "Seamless Integrations",
        description:
            "Plug into any CRM, payment processor, or community tool. Your entire stack works as one.",
        icon: "/images/service/service-icon-4.svg",
        delay: "0.90",
    },
    {
        title: "True Partnership",
        description:
            "We treat your product as our own, proactive, transparent, and always optimizing for what's next.",
        icon: "/images/service/service-icon-4.svg",
        delay: "1.10",
    }
];

export const valuePropositionSection4: ValuePropositionSectionType4[] = [
    {
        title: "We're GTM Specialists",
        description:
            "We focus on platforms and products for the creator economy, mapping every launch to real business outcomes, not just vanity metrics.",
        icon: "/images/service/service-icon-1.svg",
        delay: "0.30",
    },
    {
        title: "We're Data-Driven",
        description:
            "Every strategy and campaign is grounded in analytics, so you can learn, adapt, and scale with confidence.",
        icon: "/images/service/service-icon-2.svg",
        delay: "0.50",
    },
    {
        title: "We Bridge Acquisition and Retention",
        description:
            "We design for sustainable growth by focusing on ongoing engagement, ensuring your traction compounds over time.",
        icon: "/images/service/service-icon-3.svg",
        delay: "0.70",
    },
    {
        title: "We Master Cross-Channel Strategy",
        description:
            "We integrate paid, organic, community, and partnership-led growth to give your platform maximum reach.",
        icon: "/images/service/service-icon-4.svg",
        delay: "0.90",
    },
    {
        title: "We Believe in Continuous Optimization",
        description:
            "Growth isn't a one-time event. We partner with you for the long term, providing regular insights and experiments to maintain your momentum.",
        icon: "/images/service/service-icon-4.svg",
        delay: "1.10",
    }
];

export const testimonials: TestimonialType[] = [
    {
        image: "/images/testimonial/Testimonial-1.png",
        content:
            "Desilo team quickly understood our business requirements and were proactive and flexible with our ongoing support and developments. You can definitely trust them for complex project requirements as they are top-notch in their field and we can only recommend it.",
        name: "Jenny Bennett",
        designation: "Senior Marketing Manager at Caya",
    },
    {
        image: "/images/testimonial/Testimonial-2.png",
        content:
            "Working with Desilo has been a breeze. Their understanding of our needs and ability to deliver fast, efficient solutions is truly impressive. Highly recommended for any business looking to scale.",
        name: "Michael Thomson",
        designation: "Product Head at NovaTech",
    },
    {
        image: "/images/testimonial/Testimonial-3.png",
        content:
            "From start to finish, Desilo provided exceptional service. Their team is skilled, responsive, and extremely professional. I’d definitely collaborate with them again.",
        name: "Emily Carter",
        designation: "Co-founder at DigitalLeap",
    },
];

export const testimonials2: TestimonialType[] = [
    {
        content:
            `"I've been working with Parthik and his team on several projects. I'm really pleased with his communication, timeliness and willingness to finish the project to complete satisfaction. I'd highly recommend the quality of his work to anyone."`,
        name: "John McPhail",
        designation: "Founder, at Cabotto",
        company: "Cabotto",
        image: "/images/clients/cabotto.svg",
    },
    {
        content:
            `"Highly impressed with Team Desilo's work communication on point and lightning-fast delivery. I wholeheartedly recommend them!"`,
        name: "Victordemite",
        designation: "Product Manager",
        company: "Dommarket",
        image: "/images/clients/cabotto.svg",
    },
    {
        content:
            `"Exceptional work. Parthik took what was inside my head, and turned it into a masterpiece. Easy to communicate with, highly recommended!"`,
        name: "Jenny Mapes",
        designation: "Operations Lead",
        company: "CrossFunction Sports Massage",
        image: "/images/clients/cabotto.svg",
    },
];

export const testimonials3: Testimonial1Type[] = [
    {
        description:
            "From the initial concept development to the final execution, Emily's ability to understand our brand values and target audience was evident throughout the entire process. She masterfully crafted a visually compelling and cohesive brand identity that perfectly.",
        image: "/images/testimonial/testimonial-author-2-1.png",
        name: "Jenny Bennett",
        profession: "Senior Marketing Manager at Caya",
    },
    {
        description:
            "From the initial concept development to the final execution, Emily's ability to understand our brand values and target audience was evident throughout the entire process. She masterfully crafted a visually compelling and cohesive brand identity that perfectly.",
        image: "/images/testimonial/testimonial-author-2-2.png",
        name: "Nathan Hallmark",
        profession: "Designer Team Head at Qxygen",
    },
    {
        description:
            "From the initial concept development to the final execution, Emily's ability to understand our brand values and target audience was evident throughout the entire process. She masterfully crafted a visually compelling and cohesive brand identity that perfectly.",
        image: "/images/testimonial/testimonial-author-2-3.png",
        name: "Danny Aronson",
        profession: "Senior Brand Design at Goodnotes",
    },
    {
        description:
            "From the initial concept development to the final execution, Emily's ability to understand our brand values and target audience was evident throughout the entire process. She masterfully crafted a visually compelling and cohesive brand identity that perfectly.",
        image: "/images/testimonial/testimonial-author-2-1.png",
        name: "Jenny Bennett",
        profession: "Senior Marketing Manager at Caya",
    },
    {
        description:
            "From the initial concept development to the final execution, Emily's ability to understand our brand values and target audience was evident throughout the entire process. She masterfully crafted a visually compelling and cohesive brand identity that perfectly.",
        image: "/images/testimonial/testimonial-author-2-2.png",
        name: "Nathan Hallmark",
        profession: "Designer Team Head at Qxygen",
    },
    {
        description:
            "From the initial concept development to the final execution, Emily's ability to understand our brand values and target audience was evident throughout the entire process. She masterfully crafted a visually compelling and cohesive brand identity that perfectly.",
        image: "/images/testimonial/testimonial-author-2-3.png",
        name: "Danny Aronson",
        profession: "Senior Brand Design at Goodnotes",
    },
];

export const blogs: BlogType[] = [
    {
        title: "Reveal business opportunities with our five-point brand audit",
        date: "March 8, 2024",
        imageUrl: "/images/blog/blog-thumb-1.png",
        url: "/blog-details",
        tag: "Best Practices",
    },
    {
        title: "Desilo agency revolutionizes work with the power of AI-driven solutions",
        date: "March 8, 2024",
        imageUrl: "/images/blog/blog-thumb-2.png",
        url: "/blog-details",
        tag: "About Desilo",
    },
    {
        title: "How young leaders can take charge of their professional growth",
        date: "March 8, 2024",
        imageUrl: "/images/blog/blog-thumb-3.png",
        url: "/blog-details",
        tag: "Best Practices",
    },
    {
        title: "Accessible and Inclusive Design: Welcoming All Users",
        date: "March 8, 2024",
        imageUrl: "/images/blog/blog-thumb-4.png",
        url: "/blog-details",
        tag: "About Desilo",
    },
    {
        title: "Common UX pain in design related projects you must know",
        date: "March 8, 2024",
        imageUrl: "/images/blog/blog-thumb-5.png",
        url: "/blog-details",
        tag: "Best Practices",
    },
    {
        title: "How to bring fold to your startup company with Desilo",
        date: "March 8, 2024",
        imageUrl: "/images/blog/blog-thumb-6.png",
        url: "/blog-details",
        tag: "About Desilo",
    },
    {
        title: "Simple guide to retrieval auto generated read content models",
        date: "March 8, 2024",
        imageUrl: "/images/blog/blog-thumb-7.png",
        url: "/blog-details",
        tag: "Best Practices",
    },
    {
        title: "How to manage a talented and successful design team",
        date: "March 8, 2024",
        imageUrl: "/images/blog/blog-thumb-8.png",
        url: "/blog-details",
        tag: "About Desilo",
    },
    {
        title: "We are on the quest for exceptional talent to join our team",
        date: "March 8, 2024",
        imageUrl: "/images/blog/blog-thumb-9.png",
        url: "/blog-details",
        tag: "Best Practices",
    },
];

export const blogs2: BlogType[] = [
    {
        date: "March 8, 2024",
        title: "Reveal business opportunities with our five point brand audit",
        description: "Description of the blog...",
        imageUrl: "/images/blog/blog-thumb-1.png",
        url: "/blog-details",
    },
    {
        date: "March 8, 2024",
        title: "Desilo agency revolutionizes work with the power of AI-driven",
        description: "Description of the blog...",
        imageUrl: "/images/blog/blog-thumb-2.png",
        url: "/blog-details",
    },
    {
        date: "March 8, 2024",
        title: "How young leaders can take charge of their professional growth",
        description: "Description of the blog...",
        imageUrl: "/images/blog/blog-thumb-3.png",
        url: "/blog-details",
    },
];

export const blogs3: Blog2Type[] = [
    {
        date: "March 8, 2024",
        title: "Reveal business opportunities with our five point brand audit",
        imgSrc: "/images/blog/blog-thumb-1.png",
    },
    {
        date: "March 8, 2024",
        title: "Desilo agency revolutionizes work with the power of ai-driven",
        imgSrc: "/images/blog/blog-thumb-2.png",
    },
    {
        date: "March 8, 2024",
        title: "How young leaders can take charge of their professional growth",
        imgSrc: "/images/blog/blog-thumb-3.png",
    },
    {
        date: "March 8, 2024",
        title: "Accessible and Inclusive Design: Welcoming All Users",
        imgSrc: "/images/blog/blog-thumb-4.png",
    },
    {
        date: "March 8, 2024",
        title: "Common UX pain in design related projects you must know",
        imgSrc: "/images/blog/blog-thumb-5.png",
    },
    {
        date: "March 8, 2024",
        title: "How to bring fold to your startup company with Desilo",
        imgSrc: "/images/blog/blog-thumb-6.png",
    },
    {
        date: "March 8, 2024",
        title: "Simple guide to retrieval auto generated read content models",
        imgSrc: "/images/blog/blog-thumb-7.png",
    },
    {
        date: "March 8, 2024",
        title: "We are on the quest for exceptional talent to join our team",
        imgSrc: "/images/blog/blog-thumb-9.png",
    },
];

export const social: SocialType[] = [
    { href: "https://www.facebook.com/desilo.studio/", iconClass: "fab fa-facebook" },
    { href: "https://x.com/DesiloStudio", iconClass: "fab fa-x-twitter" },
    { href: "https://in.linkedin.com/company/desilostudio", iconClass: "fab fa-linkedin" },
    { href: "https://www.instagram.com/desilo.studio/", iconClass: "fab fa-instagram" },
];
export const social_footer: SocialType[] = [
    {
        href: "https://www.facebook.com/desilo.studio/",
        iconClass: "fab fa-facebook fs-5"
    },
    {
        href: "https://x.com/DesiloStudio",
        iconClass: "fab fa-x-twitter fs-5"
    },
    {
        href: "https://in.linkedin.com/company/desilostudio",
        iconClass: "fab fa-linkedin fs-5"
    },
    {
        href: "https://www.instagram.com/desilo.studio/",
        iconClass: "fab fa-instagram fs-5"
    },
];

export const agencyLinks: LinkType[] = [
    { href: "/service", label: "Services" },
    { href: "/work", label: "Work" },
    { href: "/blog", label: "Blog" },
    { href: "/about", label: "About" },
    { href: "/contact", label: "Contact" },
];
export const agencyLinks2: LinkType[] = [
    { href: "/startup", label: "Startups" },
    { href: "/agency-manager", label: "Agency" },
    { href: "/established-growing", label: "Established & Growing" },
    { href: "/creator", label: "Creator" }
];

export const servicesLinks: LinkType[] = [
    { href: "/service-details", label: "Brand Strategy" },
    { href: "/service-details", label: "Web Development" },
    { href: "/service-details", label: "UI/UX Design" },
    { href: "/service-details", label: "Digital Marketing" },
];

export const footerLink: LinkType[] = [
    { label: "Agency", href: "/" },
    { label: "Careers", href: "/career" },
    { label: "Privacy", href: "/privacy" },
    { label: "Testimonials", href: "/testimonials" },
];

export const footerSocial: LinkType[] = [
    {
        label: "Twitter",
        href: "https://x.com",
    },
    {
        label: "Instagram",
        href: "https://instagram.com",
    },
    {
        label: "LinkedIn",
        href: "https://linkedin.com",
    },
    {
        label: "Behance",
        href: "https://behance.net",
    },
    {
        label: "Dribbble",
        href: "https://dribbble.com",
    },
];

export const services: ServiceType[] = [
    {
        title: "Advanced Digital Solution",
        description:
            "Brand identity design a the have to success whether you breath onfire desilo agency.",
        icon: "/images/service/service-icon-1.svg",
        delay: "0.30",
    },
    {
        title: "UI/UX & Product Innovation",
        description:
            "Brand identity design a the have to success whether you breath onfire desilo agency.",
        icon: "/images/service/service-icon-2.svg",
        delay: "0.45",
    },
    {
        title: "Market Analysis & Planning",
        description:
            "Brand identity design a the have to success whether you breath onfire desilo agency.",
        icon: "/images/service/service-icon-3.svg",
        delay: "0.60",
    },
    {
        title: "Business Campaign Strategy",
        description:
            "Brand identity design a the have to success whether you breath onfire desilo agency.",
        icon: "/images/service/service-icon-4.svg",
        delay: "0.75",
    },
];

export const icp: ICPType[] = [
    {
        title: "Startups",
        description:
            "Launch an investor-ready MVP, validate fast, and scale on the same stack. Tech turns distribution, monetization, and trust into a repeatable business.",
        points: [
            "Rapid MVP development",
            "Scalable architecture",
            "Investor-ready demos",
        ],
        link: "/startup",
        icon: "/images/icp/startups.svg",
    },
    {
        title: "Agencies & Creator managers",
        description:
            "Win more brand deals and run ops faster. Centralize briefs, rates, contracts, and approvals, with attribution and automation to lift win-rate and margins.",
        points: [
            "Performance optimization",
            "Advanced analytics",
            "AI integrations",
        ],
        link: "/agency-manager",
        icon: "/images/icp/media-agency.svg",
    },
    {
        title: "Established & Growing",
        description:
            "Upgrade experience and build owned communities. Add applied AI on secure integrations so personalization and automation make loyalty and revenue compound.",
        points: [
            "Performance optimization",
            "Advanced analytics",
            "AI integrations",
        ],
        link: "/established-growing",
        icon: "/images/icp/enterprise.svg",
    },
    {
        title: "Creators",
        description:
            "Post with rhythm and earn predictable income. Own your audience, automate distribution, and measure what works so trust and revenue grow.",
        points: [
            "Rapid MVP development",
            "Scalable architecture",
            "Investor-ready demos",
        ],
        link: "/creator",
        icon: "/images/icp/creator.svg",
    },
];

export const icpServiceOther1: ICPServiceOtherType1[] = [
    {
        id: 1,
        title: "Speed vs quality",
        description:
            "you need an MVP fast, but you cannot afford throwaway code.",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        id: 2,
        title: "Murky signals",
        description:
            "traction feels noisy, making PMF and roadmap bets unclear.",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        id: 3,
        title: "Stack sprawl",
        description:
            "auth, paywalls, analytics, and integrations are half wired.",
        icon: "/images/service/service-icon-3.svg",
    },
    {
        id: 4,
        title: "Investor story",
        description:
            "you lack crisp dashboards and proof to raise with confidence.",
        icon: "/images/service/service-icon-4.svg",
    },
];
export const icpServiceOther2: ICPServiceOtherType2[] = [
    {
        id: 1,
        title: "Inconsistent posting",
        description:
            "Cadence breaks and momentum stalls.",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        id: 2,
        title: "Algorithm dependence",
        description:
            "Reach and revenue swing without warning.",

        icon: "/images/service/service-icon-2.svg",
    },
    {
        id: 3,
        title: "Monetization friction",
        description:
            "Fans do not convert to paid or do not stick.",
        icon: "/images/service/service-icon-3.svg",
    },
    {
        id: 4,
        title: "Manual grind",
        description:
            "DMs, support, and admin eat the time you should creat",
        icon: "/images/service/service-icon-4.svg",
    },
];

export const icpServiceOther3: ICPServiceOtherType3[] = [
    {
        id: 1,
        title: "Legacy experience",
        description:
            "Dated UX and slow flows hurt conversion and NPS.",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        id: 2,
        title: "Data silos",
        description:
            "No single view of users across product, community, and CRM.",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        id: 3,
        title: "Governance at scale",
        description:
            "SSO, SCIM, audit logs, and permissions block deals.",
        icon: "/images/service/service-icon-3.svg",
    },
    {
        id: 4,
        title: "Slow experiments",
        description:
            "Shipping takes too long, ROI is hard to prove.",
        icon: "/images/service/service-icon-4.svg",
    },
];

export const icpServiceOther4: ICPServiceOtherType4[] = [
    {
        id: 1,
        title: "Deal chaos",
        description:
            "briefs, rates, and contracts live in too many places.",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        id: 2,
        title: "Bandwidth cap",
        description:
            "one manager cannot efficiently handle more creators.",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        id: 3,
        title: "Brand safety and approvals",
        description:
            "compliance slows campaigns and adds risk.",
        icon: "/images/service/service-icon-3.svg",
    },
    {
        id: 4,
        title: "Reporting gaps",
        description:
            "unclear performance, late invoices, and unhappy stakeholders.",
        icon: "/images/service/service-icon-4.svg",
    },
];

export const projects: Project2Type[] = [
    {
        title: "Kinetic Sandscapes",
        image: "/images/project/project-2-1.png",
        date: "2024",
        category: "Branding",
    },
    {
        title: "Hopscotch Payments",
        image: "/images/project/project-2-2.png",
        date: "2024",
        category: "Development",
    },
    {
        title: "Brooklyn Brewery",
        image: "/images/project/project-2-3.png",
        date: "2024",
        category: "Photography",
    },
    {
        title: "Stories Worthwhile",
        image: "/images/project/project-2-4.png",
        date: "2024",
        category: "UI/UX Design",
    },
    {
        title: "Regenerative Farming",
        image: "/images/project/project-2-5.png",
        date: "2024",
        category: "Branding",
    },
    {
        title: "Fintech Accelerator",
        image: "/images/project/project-2-6.png",
        date: "2024",
        category: "UI/UX Design",
    },
];

export const teamMembers: TeamMemberType[] = [
    {
        name: "Parthik P.",
        position: "Founder + Design Director",
        description: "Product strategist for the creator economy, turning ideas into MVPs, PMF, and owned growth.",
        image: "/images/about/parthik.png",
        socialLinks: {
            linkedin: "https://www.linkedin.com/in/parthikp/",
        },
        link: "/parthik"
    },
    {
        name: "Chirag P.",
        position: "Co-Founder + CTO",
        description: "Product and engineering lead who ships reliable systems that scale without a rebuild.",
        image: "/images/about/chirag.png",
        socialLinks: {
            linkedin: "https://www.linkedin.com/in/chiragposhiya",
        },
        link: "/chirag"
    }
];

export const awards: AwardType[] = [
    {
        title: "Winner - Best eCommerce Websites",
        info: "Awwwards ─ 2023",
    },
    {
        title: "Awarded - Top Creative Agency in United State",
        info: "Envato Elements ─ 2022",
    },
    {
        title: "Mentioned - Honorable Mentioned",
        info: "Design Community ─ 2022",
    },
    {
        title: "Winner - Behance Portfolio Review",
        info: "Behance ─ 2021",
    },
    {
        title: "Winner - Featured App Design of the Week",
        info: "UI/UX Global Award ─ 2019",
    },
];

export const pricingPlans: PricingPlanType[] = [
    {
        title: "Standard",
        description: "Ideal for small businesses or startups.",
        price: "$990",
        features: [
            "Access to all basic features",
            "Work customization",
            "Mobile and desktop app",
            "Access to all design templates",
            "Priority customer support",
        ],
    },
    {
        title: "Professional",
        description: "Ideal for small businesses or startups.",
        price: "$1800",
        features: [
            "Access to all basic features",
            "Work customization",
            "Mobile and desktop app",
            "Access to all design templates",
            "Priority customer support",
        ],
    },
    {
        title: "Enterprise",
        description: "Ideal for small businesses or startups.",
        price: "$2900",
        features: [
            "Access to all basic features",
            "Work customization",
            "Mobile and desktop app",
            "Access to all design templates",
            "Priority customer support",
        ],
    },
];

export const workingProcess = [
    {
        title: "Send Email",
        description:
            "Listen stories of user, understand points, and give an estimate about cost and time-frame.",
    },
    {
        title: "Meet Online",
        description:
            "Listen stories of user, understand points, and give an estimate about cost and time-frame.",
    },
    {
        title: "Price Estimation",
        description:
            "Listen stories of user, understand points, and give an estimate about cost and time-frame.",
    },
    {
        title: "Work Together",
        description:
            "Listen stories of user, understand points, and give an estimate about cost and time-frame.",
    },
    {
        title: "Send Email",
        description:
            "Listen stories of user, understand points, and give an estimate about cost and time-frame.",
    },
    {
        title: "Meet Online",
        description:
            "Listen stories of user, understand points, and give an estimate about cost and time-frame.",
    },
    {
        title: "Price Estimation",
        description:
            "Listen stories of user, understand points, and give an estimate about cost and time-frame.",
    },
    {
        title: "Work Together",
        description:
            "Listen stories of user, understand points, and give an estimate about cost and time-frame.",
    },
];

export const faq = [
    {
        id: 0,
        question: "Who is Desilo best for?",
        answer: "We're ideal for startups working toward MVP or PMF, creators turning audiences into revenue, agencies managing multiple creators, and established teams modernizing UX with applied AI."
    },
    {
        id: 1,
        question: "How do we get start?",
        answer: "Book a free strategy call. If there's a fit, we'll launch a short discovery sprint and provide you with a detailed plan including scope, milestones, and metrics."
    },
    {
        id: 2,
        question: "What's \"consulting-driven\" about your work?",
        answer: "We go beyond design and development to help define the strategy. You'll receive research, strategy, experiments, and a roadmap aligned with measurable outcomes."
    },
    {
        id: 3,
        question: "Can you launch an MVP fast and still scale later?",
        answer: "Absolutely. We deliver investor-ready MVPs with scalability in mind, including a design system, modular architecture, analytics, and governance to prevent costly rebuilds."
    },
    {
        id: 4,
        question: "Do you implement AI?",
        answer: "Yes, but only where they drive key metrics. This could include onboarding assistants, recommendation engines, summarizers, support agents, or workflow automation connected to real outcomes."
    },
    {
        id: 5,
        question: "What's your pricing model?",
        answer: "We offer fixed-scope packages for MVPs and monthly product pods for growth and enterprise work. You'll receive transparent estimates, milestone billing, and no hidden fees."
    }
];

export const bfsfaq = [
    {
        id: 0,
        question: "How do you handle NDAs and confidentiality?",
        answer: "We sign NDAs before any technical discussion. All work is treated as confidential and we never disclose client projects without permission."
    },
    {
        id: 1,
        question: "What's your typical timeline?",
        answer: "Discovery takes 1 week. MVP builds run 8-12 weeks. Ongoing product work operates in 2-week sprints with weekly demos."
    },
    {
        id: 2,
        question: "Which tech stacks do you work with?",
        answer: "Modern web: React, Next.js, Node.js, Python. Mobile: React Native, Swift, Kotlin. Infrastructure: AWS, GCP, Docker, Kubernetes. We recommend stacks based on your scaling needs."
    },
    {
        id: 3,
        question: "Do you work remotely or require onsite presence?",
        answer: "We operate globally with distributed delivery. Core team is based in Ahmedabad, India. We've shipped products for clients across North America, GCC, and Europe."
    },
    {
        id: 4,
        question: "Can you take over an existing codebase?",
        answer: "Yes. We conduct architecture audits, identify technical debt, and plan migration-safe refactors. Many clients come to us for rescue and rebuild projects."
    }
];

export const creatorFaqs = [
    {
        id: 0,
        question: "How fast can you get an MVP live?",
        answer: "Typical MVP is 6 to 12 weeks after a 1 to 2 week discovery sprint. We timebox, demo weekly, and ship a usable v1, not a throwaway prototype."
    },
    {
        id: 1,
        question: "Will we need to rebuild to scale later?",
        answer: "No. We use a modular stack, a design system, and clean analytics so you can harden the same codebase as traction grows."
    },
    {
        id: 2,
        question: "Do you include AI in the first version?",
        answer: "Where it helps. Common starters are onboarding assistants, smart recommendations, and support summaries tied to measurable KPIs."
    },
    {
        id: 3,
        question: "What does pricing look like?",
        answer: "Fixed scope for MVP. Product pods monthly for growth. Transparent estimates and milestone billing."
    },
    {
        id: 4,
        question: "Who owns the IP and code?",
        answer: "You do. You receive repos, design files, and documentation. Our accelerators remain ours but the deliverable for your product is yours."
    },
    {
        id: 5,
        question: "How do you measure success?",
        answer: "Activation, time to first value, paid conversion, retention, and CAC payback. We set dashboards on day one."
    }
];

export const scalingFaqs = [
    {
        id: 0,
        question: "Do we need a full rebuild to modernize?",
        answer: "Usually not. We phase replatforming. Start with journeys, design system, and high impact flows, then expand."
    },
    {
        id: 1,
        question: "Will this fit our stack and data model?",
        answer: "Yes. We integrate with your CDP or CRM, respect existing schemas, and map clean contracts for new services."
    },
    {
        id: 2,
        question: "Can you meet our security and governance standards?",
        answer: "Yes. SSO, SCIM, RBAC, audit logs, encryption, data residency options, and documented processes aligned to SOC2 and ISO controls."
    },
    {
        id: 3,
        question: "How do you personalize without creeping out users?",
        answer: "Segment level journeys and transparent controls. We minimize data, log decisions, and honor consent preferences."
    },
    {
        id: 4,
        question: "How do you avoid downtime during migration?",
        answer: "Feature flags, parallel runs, and rollbacks. We scope dark launches and incremental cutovers."
    },
    {
        id: 5,
        question: "How do we prove ROI to leadership?",
        answer: "We set baseline metrics and dashboards. Expect conversion lift, retention gains, LTV impact, ticket deflection, and cycle time improvements tracked by cohort."
    }
];

export const agenciesFaqs = [
    {
        id: 0,
        question: "Will this work with our existing CRM and inbox?",
        answer: "Yes. We integrate pipelines, email, e-sign, and payouts so your team does not change tools overnight."
    },
    {
        id: 1,
        question: "How do you keep campaigns brand safe?",
        answer: "Role based access, approvals, audit trails, and rights management. We design for compliance from the start."
    },
    {
        id: 2,
        question: "What do your AI agents actually do?",
        answer: "Outreach drafting, chatter replies, support summaries, and follow ups. You set tone and guardrails and humans stay in control."
    },
    {
        id: 3,
        question: "Can one manager handle more creators with this?",
        answer: "That is the goal. Centralized briefs, templates, calendars, and automated reminders increase capacity without burning people out."
    },
    {
        id: 4,
        question: "How do clients see progress?",
        answer: "Client portals with live dashboards, deliverable status, and exportable reports. Fewer update emails, more clarity."
    },
    {
        id: 5,
        question: "How do you price agency work?",
        answer: "Discovery first, then a platform scope and a retainer for ops automation and reporting. Clear SLAs included."
    }
];

export const startupFaqs = [
    {
        id: 0,
        question: "How fast can you get an MVP live?",
        answer: "Typical MVP is 6 to 12 weeks after a 1 to 2 week discovery sprint. We timebox, demo weekly, and ship a usable v1, not a throwaway prototype."
    },
    {
        id: 1,
        question: "Will we need to rebuild to scale later?",
        answer: "No. We use a modular stack, a design system, and clean analytics so you can harden the same codebase as traction grows."
    },
    {
        id: 2,
        question: "Do you include AI in the first version?",
        answer: "Where it helps. Common starters are onboarding assistants, smart recommendations, and support summaries tied to measurable KPIs."
    },
    {
        id: 3,
        question: "What does pricing look like?",
        answer: "Fixed scope for MVP. Product pods monthly for growth. Transparent estimates and milestone billing."
    },
    {
        id: 4,
        question: "Who owns the IP and code?",
        answer: "You do. You receive repos, design files, and documentation. Our accelerators remain ours but the deliverable for your product is yours."
    },
    {
        id: 5,
        question: "How do you measure success?",
        answer: "Activation, time to first value, paid conversion, retention, and CAC payback. We set dashboards on day one."
    }
];

export const careerTimeline: CareerTimelineType[] = [
    {
        title: "Content Marketing Executive",
        location: "California, United States",
        deadline: "31 December, 2024",
        roles: 4,
    },
    {
        title: "Front End Developer",
        location: "California, United States",
        deadline: "8 January, 2025",
        roles: 1,
    },
    {
        title: "Communication Executive",
        location: "California, United States",
        deadline: "8 January, 2025",
        roles: 2,
    },
    {
        title: "Senior Product Designer",
        location: "California, United States",
        deadline: "20 February, 2025",
        roles: 2,
    },
];

export const bfsServices: BfsServiceType[] = [
    {
        title: "Creator Monetization Platforms",
        description:
            "Launch lightweight subscription, tipping, or paywalled-content tools to validate user demand fast.",
        link: "/use-case/creator-monetization-platform",
        icon: "/images/service/service-icon-2.svg",
    },
    {
        title: "Campaign & Brand Deal Workflow ",
        description:
            "Briefs, deliverables, approvals, and reporting in one pipeline to reduce chaos and lost margins.",
        link: "/use-case/campaign-workflow-automation",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        title: "Outbound Sales Intelligence for Brand Partnerships ",
        description:
            "Proposal generators, case-study builders, and performance snapshots to win deals faster.",
        link: "/use-case/outbound-sales-pitch-intelligence",
        icon: "/images/service/service-icon-1.svg",
    },
    {
        title: "Creator-Led SaaS (AI + Workflow Tools)",
        description:
            "Ship early AI copilots for content repurposing, scriptwriting, or collab outreach to test traction.",
        link: "/use-case/creator-led-saas",
        icon: "/images/service/service-icon-2.svg",
    },
];